import { __decorate, __extends } from "tslib";
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { createUser } from '../../api/users';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';
import { isValidEmailFormat } from '../../utils/utils';
import S from './admins.styl';
var AdminDetailsModal = /** @class */ (function (_super) {
    __extends(AdminDetailsModal, _super);
    function AdminDetailsModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            emailInputError: false,
            passwordInputError: false,
            firstNameInputError: false,
            lastNameInputError: false,
        };
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'email') {
                _this.setState({ emailInputError: false });
            }
            if (name === 'password') {
                _this.setState({ passwordInputError: false });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        _this.onClose = function () {
            if (_this.props.onClose) {
                _this.props.onClose();
            }
        };
        return _this;
    }
    AdminDetailsModal.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var email = elements.email.value;
        var password = elements.password.value;
        var firstName = elements.firstName.value;
        var lastName = elements.lastName.value;
        if (!isValidEmailFormat(email)) {
            this.setState({ emailInputError: true });
            valid = false;
        }
        if (password.length === 0) {
            this.setState({ passwordInputError: true });
            valid = false;
        }
        if (!valid) {
            return;
        }
        var request = {
            email: email,
            password: password,
            firstName: firstName,
            lastName: lastName,
            environment: 'web',
            deviceId: navigator.userAgent,
        };
        this.setState({ loading: true });
        createUser(request).then(function () {
            _this.setState({ loading: false });
            _this.isUpdated();
        }).catch(function (error) {
            _this.setState({ loading: false });
            alert(error);
        });
    };
    AdminDetailsModal.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var i18n = props.store.i18n;
        var loading = state.loading;
        return (React.createElement(Modal, { className: props.className, onRequestClose: props.onClose },
            React.createElement("div", { className: S.adminsAddView },
                React.createElement("p", { className: S.adminsHeaderText }, i18n.adminsCreateTitle),
                React.createElement("form", { className: "" + S.detailsDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                    React.createElement("div", null,
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.loginViewEmailPlaceholder),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "email", type: "email", onInput: this.onChangeAction, placeholder: i18n.loginViewEmailPlaceholder })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.emailInputError ? 'inputErrorActive' : '') }, i18n.validationEmailError),
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.loginViewPasswordPlaceholder),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "password", type: "password", onInput: this.onChangeAction, placeholder: i18n.loginViewPasswordPlaceholder })),
                        React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.passwordInputError ? 'inputErrorActive' : '') }, i18n.validationPasswordError),
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.adminsFirstName),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "firstName", onInput: this.onChangeAction, placeholder: i18n.adminsFirstNamePlaceholder })),
                        React.createElement("div", { className: S.detailsInputWrapper },
                            React.createElement("label", { className: S.detailsInputTitle }, i18n.adminsLastName),
                            React.createElement("input", { className: S.detailsInput + " textInput", name: "lastName", onInput: this.onChangeAction, placeholder: i18n.adminsLastNamePlaceholder }))),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.adminsModalButton, type: "submit", spinner: loading }, i18n.actionCreate),
                    React.createElement(Button, { className: "primaryButton fullwidthButton " + S.adminsModalButton + " " + S.adminsModalCancel, type: "button", spinner: loading, onClick: this.onClose }, i18n.alertModalCancel)))));
    };
    __decorate([
        action.bound
    ], AdminDetailsModal.prototype, "onSubmit", null);
    AdminDetailsModal = __decorate([
        inject('store'),
        observer
    ], AdminDetailsModal);
    return AdminDetailsModal;
}(React.Component));
export { AdminDetailsModal };
